import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: null,
};

export const BadgeOriginal = ({ className }) => {
  const styles = useStyles();
  return <span className={cx(styles.root, className)}>Original</span>;
};

BadgeOriginal.propTypes = propTypes;
BadgeOriginal.defaultProps = defaultProps;
